import type { AuditSummaryMode } from './types';

export function resolveAuditSummaryMode({
  isBothConnected = false,
  isBothNotConnected = false,
  isLottoConnectedOnly = false,
  isPOSConnectedOnly = false,
}: {
  isBothConnected?: boolean;
  isBothNotConnected?: boolean;
  isLottoConnectedOnly?: boolean;
  isPOSConnectedOnly?: boolean;
}): AuditSummaryMode {
  if (isBothConnected) return 'bothConnected';
  if (isPOSConnectedOnly) return 'posOnly';
  if (isLottoConnectedOnly) return 'lottoOnly';
  if (isBothNotConnected) return 'bothNotConnected';
  return 'bothNotConnected';
}

